<template>
  <el-dialog
    :visible.sync="assignHomeworkVisible"
    :before-close="handlerClose"
    :show-close="false"
    @open="open"
  >
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{ $t("jobManagementV2.AssignTask") }}</slot>
      <div class="title-right"></div>
    </div>

    <div class="tree-table">
      <div class="tree" ref="tree">
        <div class="fileter" v-if="false">
          <el-input
            v-model.trim="searchVal"
            :placeholder="$t('projectDetailsV2.search')"
            size="small"
            clearable
            @clear="changeClear"
            @focus="handleFocus"
          >
          </el-input>
          <i class="search_i" @click="handelerSeachClick"></i>
        </div>
        <div class="list-box">
          <!-- 面包屑 -->
          <div class="title">
            <!-- 全选 -->
            <el-checkbox
              v-model="checkedAll"
              @change="changeCheckedAll"
            ></el-checkbox>
            <div class="breadcrumb" ref="breadcrumb">
              <span
                v-for="(item, index) in breadcrumbList"
                :key="item.id"
                :class="{ active: index == breadcrumbList.length - 1 }"
                @click="handelerClickBread(item, index)"
              >
                {{ item.name }}
              </span>
            </div>
          </div>
          <div class="depart-box" ref="scrollBox">
            <!-- <div class="depart-box" ref="scrollBox" @scroll="toLoadMore"> -->
            <!-- 部门列表 -->
            <div class="depart-list">
              <div
                class="depart-list-item"
                v-for="item in curDepartList"
                :key="item.id"
              >
                <el-checkbox
                  v-model="item.checked"
                  @change="(val) => changeCheckBox(val, item)"
                ></el-checkbox>
                <div class="depart-info">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`${item.name}`"
                    placement="top-start"
                    :disabled="isShowTooltip"
                  >
                    <div class="depart-name" @mouseover="onMouseOver(item.id)">
                      <span :ref="`str${item.id}`">{{ item.name }}</span>
                    </div>
                  </el-tooltip>
                  <span class="depart-num">（{{ item.departCount }}）</span>
                </div>
                <div class="depart-children" v-show="item.children.length > 0">
                  <span v-if="!item.checked" @click="toChildrenDepart(item)">{{
                    $t("managementV2.subordinate")
                  }}</span>
                  <el-link type="primary" disabled v-else>{{
                    $t("managementV2.subordinate")
                  }}</el-link>
                </div>
              </div>
            </div>
            <div v-show="hasNotMore" class="hasnotmore">
              <span>{{ $t("managementV2.hasNotMore") }}...</span>
            </div>
          </div>
        </div>
        <div class="search-box" v-if="false">
          <el-card>
            <span v-if="searchList.length == 0">{{
              $t("managementV2.startSearchByKeyword")
            }}</span>
            <div v-else class="search-list">
              <!-- 人员列表 -->
              <div class="person-list">
                <!-- <div class="person-list" ref="searchScrollBox" @scroll="toLoadMoreSearch"> -->
                <div
                  class="person-list-item"
                  v-for="i in searchList"
                  :key="i.id"
                >
                  <el-checkbox
                    v-model="i.checked"
                    @change="(val) => changeSearchCheckBox(val, i)"
                    :disabled="i.companyStatus == 1"
                  ></el-checkbox>
                  <div class="person-info">
                    <span class="avtor">{{ i.nickName.charAt(0) }}</span>
                    <div class="person-name">{{ i.nickName }}</div>
                  </div>
                  <div class="hasjoin" v-if="i.companyStatus == 1">
                    <span class="join-ico"></span>
                    <span>{{ $t("managementV2.joined") }}</span>
                  </div>
                </div>
                <div v-show="hasNotMoreSearch" class="hasnotmore">
                  <span>{{ $t("managementV2.hasNotMore") }}...</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="table">
        <div class="checked-title">
          <div class="checked-title-icon"></div>
          <div class="checked-title-text">
            {{ $t("managementV2.selected") }}
          </div>
        </div>
        <div class="checked-list">
          <el-tag
            v-for="tag in checkedList"
            :key="tag.id"
            :closable="handleClosable(tag)"
            type=""
            @close="handleClose(tag)"
          >
            {{ tag.name || tag.nickName }}
          </el-tag>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handlerClose" size="small">{{
        $t("managementV2.cancel")
      }}</el-button>
      <el-button type="primary" @click="determine" size="small"
        >{{ $t("assignTaskV2.comfirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>
  <script>
import {
  queryUserDepartTree,
  getTeamUserPage,
  assignHomeworkAjax,
} from "@/services/teamManagement";
import { createClassQrCode } from "@/services/managements";
import { onCopy } from "@/utils/index";
export default {
  name: "assignHomeworkDialog",
  data() {
    return {
      params: {
        filter: {
          departId: "",
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
          nickName: "",
          identityType: 2, //只查询学生
        },
        page: 1,
        rows: 10,
      },
      jobName: "",
      selectVal: "",
      selectAll: false,
      defaultExpandedKeys: [],
      topinfo: {
        terrName: "",
        terrNum: 0,
      },
      noGroupId: null,
      Debounce: false,
      urlBase64: "",
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
        .code,
      treeData: [], //原始部门列表
      departList: [], //部门列表
      curDepartList: [], //当前部门列表
      isDefaultGroup: {}, //未分组的信息
      curGroup: {}, //当前分组
      checkedAll: false, //全选
      checkedList: [], //被选中的部门和人员
      searchVal: "", //搜索关键字
      searchList: [], //搜索结果
      isShowSearchBox: false, //是否展示搜索列表
      breadcrumbList: [], //面包屑列表
      stuPage: 1, //学生分页
      stuRows: 20, //学生条数
      searchPage: 1, //搜索分页
      searchRows: 30, //搜索条数
      hasNotMore: false, //没有更多了
      hasNotMoreSearch: false, //没有更多了结果了
      isShowTooltip: false, //展示气泡
    };
  },
  props: {
    assignHomeworkVisible: {
      type: Boolean,
      default: () => false,
    },
    globalObj: {
      type: Object,
      required: true,
    },
  },
  watch: {
    curDepartList: {
      handler(val) {
        // console.log(val, "*****");
        if (val.length > 0) {
          this.checkedAll = val.every((item) => item.checked == true);
        }
      },
      deep: true,
    },

    isShowSearchBox: {
      handler(val) {
        if (!val) {
          this.searchList = [];
        }
      },
      deep: true,
    },
    breadcrumbList: {
      handler() {
        let ele = this.$refs.breadcrumb;
        this.$nextTick(() => {
          ele.scrollLeft = ele?.scrollWidth - ele?.clientWidth;
        });
      },
    },
  },
  methods: {
    onMouseOver(str) {
      // 内容超出，显示文字提示内容
      const tag = this.$refs[`str${str}`];
      const parentWidth = tag[0].parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag[0].offsetWidth; // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth;
    },
    //全选/全不选
    changeCheckedAll(val) {
      this.curDepartList.forEach((item) => (item.checked = val));
      if (val) {
        this.checkedList = this.checkedList.filter(
          (x) => !this.curDepartList.some((y) => y.id === x.id)
        );
        this.checkedList.push(
          this.breadcrumbList[this.breadcrumbList.length - 1]
        );
      } else {
        this.checkedList = this.checkedList.filter(
          (item) =>
            item.id != this.breadcrumbList[this.breadcrumbList.length - 1].id
        );
      }
    },
    //选框改变时
    changeCheckBox(val, i) {
      this.updateChildrenChecked(val, i);
      this.updateCheckedList(val, i);
    },
    //递归跟新子部门的选值
    updateChildrenChecked(isChecked, department) {
      department.checked = isChecked;
      for (let child of department.children) {
        this.updateChildrenChecked(isChecked, child);
      }
    },
    //跟新已选择的值
    updateCheckedList(isChecked, department) {
      const parent = this.findParentDepartment(this.departList, department);
      if (isChecked) {
        // 勾选当前部门
        department.checked = isChecked;
        this.checkedList.push(department);
        if (parent) {
          // 检查父级部门的同级部门是否都被勾选了
          const siblings = parent.children;
          const isAllSiblingsChecked = siblings.every(
            (sibling) => sibling.checked
          );
          if (isAllSiblingsChecked) {
            // 所有同级部门都被勾选了，移除已选中数组中的同级部门并替换为父级
            this.checkedList = this.checkedList.filter(
              (selectedDepartment) => !siblings.includes(selectedDepartment)
            );
            // 递归检查父级部门的同级部门是否都被勾选了
            this.updateCheckedList(isChecked, parent);
          }
        }
      } else {
        // 取消勾选当前部门
        const index = this.checkedList.findIndex(
          (selectedDepartment) => selectedDepartment.id === department.id
        );
        if (index !== -1) {
          this.checkedList.splice(index, 1);
        } else {
          //如果checkedList中没有找到当前取消的部门，那么就有可能checkedList中是当前部门的父级部门或者父级的父级部门或者父级的父级的父级部门，那么需要将改部门从checkedList中移除然后把子集部门添加进去，添加的规则是，将已选中的添加进去，比如2级组织的checked为true，那么就只用添加2级组织，但是如果2级组织的checked为false，就要遍历他的children，找到为true的添加进去
          //父级部门全选的情况
          if (parent) {
            parent.checked = isChecked;
            //如果有父级部门
            let parentIndex = this.checkedList.findIndex(
              (item) => item.id == parent.id
            );
            if (parentIndex != "-1") {
              this.checkedList.splice(parentIndex, 1);
              //然后将父级部门的子部门添加进去，除了当前取消的部门
              this.addCheckedChildDepartments(parent);
            } else {
              this.updateCheckedList(false, parent);
            }
          }
        }
      }
    },

    // 找到当前部门的父级部门
    findParentDepartment(departList, department) {
      for (const item of departList) {
        if (item.children.includes(department)) {
          // 如果当前部门的子部门中包含指定部门，则返回当前部门
          return item;
        } else if (item.children && item.children.length > 0) {
          // 如果当前部门有子部门，则递归遍历其子部门
          const parent = this.findParentDepartment(item.children, department);
          if (parent) {
            // 如果在子部门中找到了指定部门的父级组织，则返回该父级组织
            return parent;
          }
        }
      }
      // 如果在整个组织架构中都没有找到指定部门的父级组织，则返回 null
      return null;
    },
    //递归添加子部门
    addCheckedChildDepartments(departments) {
      if (departments.children.length > 0) {
        departments.children.forEach((item) => {
          if (item.checked) {
            this.checkedList.push(item);
          } else {
            this.addCheckedChildDepartments(item);
          }
        });
      }
    },

    //搜索选框改变时
    changeSearchCheckBox(val, i) {
      if (val) {
        //判断有欸有
        let flag = this.checkedList.findIndex((item) => item.id == val.id);
        if (flag == "-1") {
          this.checkedList.push(i);
          this.curStudentList.forEach((item) => {
            if (item.id == i.id) {
              item.checked = true;
            }
          });
        }
      } else {
        this.checkedList.forEach((item, index) => {
          if (item.id == i.id) {
            this.checkedList.splice(index, 1);
          }
        });
        this.curStudentList.forEach((item) => {
          if (item.id == i.id) {
            item.checked = false;
          }
        });
      }
    },
    //获取当前学生成员列表
    async getCurStudentList(params) {
      params = params || {
        filter: {
          // classId: this.addstudentId,
          departId: this.curGroup.id,
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
        },
        // page: this.stuPage,
        // rows: this.stuRows,
        // sort: {},
      };
      let res = await getTeamUserPage(params);
      if (res.success) {
        // this.stuPage = this.stuPage + 1
        let arr = res.result;
        // let arr2 = []
        // let arr3 = JSON.parse(JSON.stringify(this.checkedList))
        //如果是已加入，默认选中
        arr.forEach((i) => {
          if (i.classStatus == 1) {
            i["checked"] = true;
            // arr2.push(i)
          }
        });

        // this.checkedList = arr3.reduce((a, b) => {
        //   let isFlag = false
        //   a.forEach(item => {
        //     if (item.id === b.id) {
        //       isFlag = true
        //       item = Object.assign(item, b)
        //     }
        //   })
        //   if (!isFlag) {
        //     a.push(b)
        //   }
        //   return a
        // }, arr2)
        //已选中，再次获取继续选中
        arr.forEach((i) => {
          this.checkedList.forEach((j) => {
            if (i.id == j.id) {
              i.checked = true;
            }
            if (j.id == this.curGroup.id || j.id == 1) {
              i.checked = true;
            }
          });
        });
        this.curStudentList.push(...arr);
        // if (this.curStudentList.length == res.totalRows) {
        this.hasNotMore = true;
        // }
      }
    },
    //获取被选中的部门和人员
    getCheckedList() {},
    //是否可以删除
    handleClosable(tag) {
      if (tag.hasOwnProperty("classStatus")) {
        return tag.classStatus != 1;
      } else {
        return true;
      }
    },
    //删除tag
    handleClose(tag) {
      const index = this.curDepartList.findIndex((item) => item.id == tag.id);
      if (index != "-1") {
        //在this.curDepartList找到id和tag.id相等的对象，并将其checked属性设置为false,然后把他的子部门包括子部门的子部门也的checked属性设置为false
        this.curDepartList.forEach((item) => {
          if (item.id == tag.id) {
            item.checked = false;
            if (item.children.length > 0) {
              this.setChildrenAttribute(item.children, "checked", false);
            }
          }
        });
        this.checkedList.splice(this.checkedList.indexOf(tag), 1);
      } else {
        //如果没找到就在完整的组织架构this.departList中去找，找之后将其设置为false，然后将其子部门递归设置为false
        this.checkedList.splice(this.checkedList.indexOf(tag), 1);
        this.setChildrenCheckedFalse(this.departList,tag.id)
      }
    },
    //将目标组织和其子组织的checked属性设置为false
    setChildrenCheckedFalse(departments, targetId) {
      for (let i = 0; i < departments.length; i++) {
        const department = departments[i];
        if (department.id === targetId) {
          // 找到目标组织，将其所有子部门的checked属性设置为false
          department.checked =false
          this.setChildrenAttribute(department.children, "checked", false);
          break;
        } else if (department.children && department.children.length > 0) {
          // 继续搜索子孙部门
          this.setChildrenCheckedFalse(department.children, targetId);
        }
      }
    },
    setChildrenAttribute(children, attr, value) {
      children.forEach((child) => {
        child[attr] = value;
        if (child.children && child.children.length > 0) {
          this.setChildrenAttribute(child.children, attr, value);
        }
      });
    },
    //点击搜索
    handelerSeachClick() {
      this.searchList = [];
      this.isShowSearchBox = true;
      this.searchPage = 1;
      this.searchRows = 30;
      if (this.searchVal == "") {
        this.isShowSearchBox = false;
        return;
      }
      this.search();
    },
    //搜索
    async search() {
      let params = {
        filter: {
          // classId: this.addstudentId,
          keyword: this.searchVal,
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
        },
        // page: this.searchPage,
        // rows: this.searchRows,
        // sort: {},
      };
      let res = await getTeamUserPage(params);
      if (res.success) {
        this.searchPage = this.searchPage + 1;
        let arr = res.result;
        if (arr.length == 0) {
          this.$message.warning(this.$t("managementV2.notFindResult"));
        }
        arr.forEach((i) => {
          this.checkedList.forEach((j) => {
            if (i.id == j.id) {
              i["checked"] = true;
              i["disabled"] = true;
            }
          });
        });
        this.searchList.push(...arr);
        // if (this.searchList.length == res.totalRows) {
        this.hasNotMoreSearch = true;
        // }
      }
    },
    //清空
    changeClear() {
      this.hasNotMore = false;
      this.isShowSearchBox = true;
      this.searchVal = "";
      this.searchList = [];
    },
    //获取焦点
    handleFocus() {
      this.isShowSearchBox = true;
    },
    //去下级部门
    toChildrenDepart(item) {
      this.hasNotMoreSearch = false;
      this.getBrnList(item);
      this.curDepartList = item.children;
    },
    //点击面包屑
    handelerClickBread(item, index) {
      if (index == this.breadcrumbList.length - 1) {
        return;
      } else {
        this.curGroup = item;
        this.curStudentList = [];
        this.stuPage = 1;
        this.hasNotMore = false;
        this.hasNotMoreSearch = false;
        this.getBrnList(item);
        let arr = [...item.children];
        arr.forEach((i) => {
          i.checked = false;
          this.checkedList.forEach((j) => {
            if (i.id == j.id) {
              i.checked = true;
            }
            if (j.id == i.parentId) {
              i.checked = true;
            }
          });
        });
        this.curDepartList = arr;
        // let params = {
        //   filter: {
        //     departId: item.id,
        //     companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
        //   }
        // }
        if (item.id == 1) {
          this.curGroup = this.isDefaultGroup;
        }
        this.getCurStudentList();
      }
    },
    //获取面包屑列表
    getBrnList(data) {
      let arr = [...this.treeData];
      let newArr = [];
      function getAllParentNodeIds(tree, childId, parentIds) {
        for (let i in tree) {
          let item = tree[i];
          if (item.id === childId.id) {
            //将查找到的目标数据加入结果数组中
            //可根据需求unshift(item.id)或unshift(item)
            parentIds.unshift(item);
            return true;
          }
          if (item.children && item.children.length > 0) {
            let ok = getAllParentNodeIds(item.children, childId, parentIds);
            if (ok) {
              parentIds.unshift(item);
              return true;
            }
          }
        }
        //走到这说明没找到目标
        return false;
      }
      getAllParentNodeIds(arr, data, newArr);
      this.breadcrumbList = newArr;
    },
    //滚动请求
    toLoadMore() {
      let scrollDom = this.$refs.scrollBox;
      if (
        scrollDom.clientHeight + scrollDom.scrollTop + 1 >=
        scrollDom.scrollHeight
      ) {
        // this.currentPage ++ //页数加一
        this.getCurStudentList(); //发送请求获取数据
      }
    },
    toLoadMoreSearch() {
      let scrollDom = this.$refs.searchScrollBox;
      if (
        scrollDom.clientHeight + scrollDom.scrollTop + 1 >=
        scrollDom.scrollHeight
      ) {
        this.search(); //发送请求获取数据
      }
    },
    open() {
      this.$nextTick(() => {
        document.addEventListener("click", (e) => {
          if (!this.$refs.tree?.contains(e.target))
            this.isShowSearchBox = false;
        });
      });
      this.searchVal = "";
      this.breadcrumbList = [];
      this.departList = [];
      this.curDepartList = [];
      this.curStudentList = [];
      this.checkedList = [];
      this.checkedAll = false;
      this.isShowSearchBox = false;
      this.searchList = [];
      this.getTerrClass();
    },
    //角色身份格式化
    roleFormate(row) {
      let item = this.roleArr.find((item) => item.value === row.identityType);
      return item.label;
    },
    //获取树形结构数据
    async getTerrClass() {
      let params = {
        companyCode: this.companyCode,
        identityType: 2,
      };
      let { success, result } = await queryUserDepartTree(params);
      if (success) {
        //初始面包屑列表
        this.breadcrumbList.push(result);
        this.treeData = [result];
        let arr = result.children.filter((item) => item.isDefaultGroup !== 1);
        this.isDefaultGroup = result.children.find(
          (item) => item.isDefaultGroup === 1
        );
        this.departList = [result];
        this.departList[0].children = arr;
        //去掉未分组
        this.breadcrumbList[0].children = arr;
        this.addCheckedAttribute(this.departList);

        this.curDepartList = this.departList[0].children;
        // // 拿到未分组id
        this.noGroupId = this.isDefaultGroup.id;
        this.curGroup = Object.assign(this.isDefaultGroup);
      }
    },
    //给部门列表添加checked属性
    addCheckedAttribute(departments) {
      departments.forEach((item) => {
        this.$set(item, "checked", false);
        if (item.children) {
          this.addCheckedAttribute(item.children);
        }
      });
    },
    //序号格式化
    fromateIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },

    //关闭
    handlerClose() {
      this.breadcrumbList = [];
      this.departList = [];
      this.curDepartList = [];
      this.curStudentList = [];
      this.checkedList = [];
      this.checkedAll = false;
      this.isShowSearchBox = false;
      this.hasNotMoreSearch = false;
      this.hasNotMore = false;
      this.searchList = [];
      this.$emit("handleAssignClose");
      this.jobName = "";
      this.searchVal = "";
      this.selectVal = "";
      this.selectAll = false;
    },
    //创建
    async determine() {
      if (this.Debounce) {
        return false;
      }
      this.Debounce = true;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        this.Debounce = false;
      }, 1000);
      let arr = JSON.parse(JSON.stringify(this.checkedList));
      if (arr.length > 0) {
        let departIdList = [];
        arr.forEach((item) => {
          departIdList.push(item.id);
        });
        let params = {
          fileId: this.globalObj.id,
          departIdList,
        };
        const { success } = await assignHomeworkAjax(params);
        if (success) {
          this.$message.success("分配成功");
          this.handlerClose();
          this.$emit("update");
        }
      } else {
        this.$message.warning("请选择组织");
      }
      //文件id
    },
    handleCopy() {
      onCopy(this.qrCodeUrl);
      this.$message.closeAll();
      this.$message.success(this.$t("common.copySuccess"));
    },
    //创建验证码
    async createClassQrCode() {
      let params = {
        classId: this.addstudentId,
        companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
          .code,
      };
      const { result, success } = await createClassQrCode(params);
      if (success) {
        // console.log("333")
        this.urlBase64 = "data:image/png;base64," + result.urlBase64;
        // console.log(this.urlBase64)
        this.qrCodeUrl = result.qrCodeUrl;
      }
    },
  },
};
</script>
  <style lang="less" scoped>
/deep/.el-table-column--selection {
  padding: 0px !important;

  div {
    padding: 0px !important;
  }
}
</style>
  <style lang="less" scoped>
@import "./assets/addClassDialog.less";
</style>